export default __webpack_public_path__ + "locales/zh-CN/Article.json?hash=4fd7ea40c38aaa636d5984e6221f6509";